import { render, staticRenderFns } from "./TalentProfile.vue?vue&type=template&id=fecd7fec"
import script from "./TalentProfile.vue?vue&type=script&lang=js"
export * from "./TalentProfile.vue?vue&type=script&lang=js"
import style0 from "./TalentProfile.vue?vue&type=style&index=0&id=fecd7fec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports